export default __webpack_public_path__ + "locales/bg/HotkeysPanel.json?hash=6f2c353481f7ece54af705603326d960";